<app-members-overview [analytics]="analytics"></app-members-overview>
<div class="allteams">Team overview</div>
<app-highcharts-container [teamType]="'current-team'"></app-highcharts-container>
